import { GrammarMarkType } from "../enums";

import { Element } from "../element";

import { GlyphElement } from "../glyph-element";

export const createElement = mark => mark.markType === GrammarMarkType.glyph ? new GlyphElement(mark) : new Element(mark);
//# sourceMappingURL=element.js.map
